let compare = new compareProducts(),
    comparePage = new generateCompare();
compare.init();
comparePage.init();

function compareProducts() {

  const bubbleCount = '[data-compare-bubble-count]',
        bubbleContainer = '.compare-bubble-wrapper',
        popupContainer = '.compare-popup-wrapper',
        compareBtn = '[data-add-compare]',
        comparePageBtn = '[data-compare-page-btn]',
        $bubble = document.querySelector(bubbleCount),
        $bubbleContainer = document.querySelector(bubbleContainer),
        $popupContainer = document.querySelector(popupContainer),
        $compareBtn = document.querySelectorAll(compareBtn),
        $comparePageBtn = document.querySelectorAll(comparePageBtn);

  let products = [],
      localProducts = getWithExpiry('compare_products');

  this.init = function (){
    if ( localProducts ){
      products = localProducts;
    }
    this.bubbleUpdate();
    this.compareButtonUpdate();
  };

  this.toggle = function(ele){
    const productHandle = ele.getAttribute('data-handle'),
          productImage = ele.getAttribute('data-image'),
          productTitle = ele.getAttribute('data-title'),
          productUrl = ele.getAttribute('data-url');
    let productDetails = {
          'handle': productHandle,
          'image': productImage,
          'title': productTitle,
          'url': productUrl
        },
        active = false;

    localProducts = getWithExpiry('compare_products');

    if ( localProducts ){
      products = localProducts;
    }

    //Check if product is already in the compared list
    products.forEach((product) => {
      if ( product.handle === productDetails.handle ){
        active = true;
      }
    });

    if ( active ){
      this.remove(ele, productDetails);
      this.bubbleUpdate();
      return;
    }

    if ( products.length > 3 ){
      alert('You can compare maximum 4 products');
      return;
    }

    this.add(ele, productDetails);
    this.bubbleUpdate();
  };

  this.removeItem = function(ele){
    const productHandle = ele.getAttribute('data-handle'),
          $compareBtn = document.querySelector('[data-add-compare][data-handle="' + productHandle + '"]');
    let productDetails = {'handle': productHandle};

    this.remove($compareBtn, productDetails);
    this.bubbleUpdate();

    if ( document.querySelector('.compare-table') ){
      location.reload();
    }
  };

  this.add = function(ele, productDetails){
    products.push(productDetails);
    ele.classList.add("comparing");
    setWithExpiry('compare_products', products, 86400000); //24 hours
  };

  this.remove = function(ele, productDetails){
    let newProducts = [];
    products.forEach((product) => {
      if ( product.handle !== productDetails.handle ){
        newProducts.push(product);
      }
    });
    products = newProducts;
    if ( ele ){
      ele.classList.remove('comparing');
    }
    setWithExpiry('compare_products', products, 86400000); //24 hours
  };

  this.removeAll = function(){
    products = [];
    this.compareButtonUpdate();
    this.floatToggle();
    this.bubbleUpdate();
    localStorage.removeItem('compare_products');
  };

  this.floatToggle = function(bubble){
    const $page = document.querySelector('.page');
    if ( bubble ){
      $bubbleContainer.classList.add('hide');
      $popupContainer.classList.remove('hide');
      $page.classList.add('no-inner-pointer-events');
      addEvent($page, 'click', closePopup);
      return;
    }
    closePopup();
    removeEvent($page, 'click', closePopup);

    function closePopup(e){
      if (e){
        e.preventDefault();
      }
      $bubbleContainer.classList.remove('hide');
      $popupContainer.classList.add('hide');
      $page.classList.remove('no-inner-pointer-events');
    }
  };

  this.bubbleUpdate = function(){
    this.popupUpdate();
    if ( products.length > 0 ){
      $bubbleContainer.classList.remove('hide');
      $bubble.innerHTML = `(${products.length})`;
      return;
    }
    $bubbleContainer.classList.add('hide');
    $bubble.innerHTML = '';
  };

  this.popupUpdate = function(){
    popupProducts();
    comparePageBtnUpdate();

    function popupProducts(){
      const $popupProductsContainer = document.querySelector('[data-compare-products]');
      let productsHtml = '';

      products.forEach((product) => {
        productsHtml += '<div data-compare-product>' + 
                          '<a class="remove-compare-item" onclick="compare.removeItem(this);" data-handle="' + product.handle + '">X</a>' +
                          '<a href="' + product.url + '">' +
                            '<img src="' + product.image + '" />' +
                            '<span>' + product.title + '</span>' +
                          '</a>' +
                        '</div>';
      });
  
      if ( productsHtml === '' ){
        productsHtml = '<span class="empty">Please add items to compare.</span>'
      }
  
      $popupProductsContainer.innerHTML = productsHtml;
    }

    function comparePageBtnUpdate(){
      let buttonUrl = '/pages/compare';
      products.forEach((product, i) => {
        if ( i === 0 ){
          buttonUrl += '?'
        } else {
          buttonUrl += '&'
        }
        buttonUrl += 'handle=' + product.handle;
      });

      $comparePageBtn.forEach(($btn) => {
        $btn.setAttribute('href', buttonUrl);
      });
    }
  };

  this.compareButtonUpdate = function(){
    $compareBtn.forEach(($button) => {
      const handle = $button.getAttribute('data-handle'),
            match = products.filter(product => product.handle === handle);

      if ( match.length > 0 ) {
        $button.classList.add('comparing');
      } else {
        $button.classList.remove('comparing');
      }
    });
  };

}

function generateCompare(){

  const comparePage = '.compare-table',
        noProduct = '.no-compare-products',
        $comparePage = document.querySelector(comparePage),
        $noProduct = document.querySelector(noProduct);

  let products = [],
      localProducts = getWithExpiry('compare_products'),
      productMetafields = [];

  this.init = function (){
    if ( $comparePage === null ){
      return;
    }

    if ( localProducts ){
      products = localProducts;
    }
    if ( products.length === 0 ){
      $comparePage.classList.add('hide');
      $noProduct.classList.remove('hide');
      return;
    }

    $comparePage.setAttribute('data-quantity', products.length);
    // includeEmptyProducts();

    this.getMetafields(function(){
      //Run function after ajax calls
      this.buildHtml();
    }.bind(this));

    function includeEmptyProducts(){
      let dif = 4 - products.length;

      for ( var i = 0; i < dif; i++ ){
        products.push(null);
      }
    }

  };

  this.getMetafields = function(callback){
    let i = 0;

    one();

    function two(){
      i += 1;
      if ( i < products.length ){
        one();
      } else {
        if ( callback ){
          callback();
        }
      }
    }

    function one(){

      if ( products[i] === null ){
        productMetafields.push(null);
        two();
        return;
      }

      let metafields,
          jsonUrl = '/products/' + products[i].handle + '?view=json';
      
      get(jsonUrl)
      .then((data) => {
        let jsonData = JSON.parse(data);
        metafields = jsonData;
        productMetafields.push(metafields);
        two();
      })
      .catch((err) => {
        console.log('An error had occurred');
        console.log(err);
      });
    }

  };

  this.buildHtml = function(){
    let compareHtml = '';

    buildRemoveBtn();

    for (const [key, value] of Object.entries(fieldsOrder)) {
      if ( key === 'metafields' ){
        buildMetafields(key, value);
        continue;
      }
      buildMain(key, value);
    }

    $comparePage.innerHTML = compareHtml;

    function buildRemoveBtn(){
      products.forEach((product, i) => {
        if ( product === null ){
          return;
        }

        compareHtml += `<a class="remove-compare-item" data-product-position="${i}" onclick="compare.removeItem(this);" data-handle="${product.handle}">X</a>`;
      });
    }

    function buildMetafields(key, value){
      for (const [metaKey, metaValue] of Object.entries(metafieldOrder)) {
        let hasValue = false;

        //Check if any products has a value for the metafield
        productMetafields.forEach((product, i) => {
          if ( product === null ){
            return;
          }

          if ( product.metafields[metaKey] ){
            hasValue = true;
          }
        });
        //Skip metafield if all compare products do not have a value
        if ( hasValue === false ){
          continue;
        }

        compareHtml += '<div class="row" data-metafield-row>' + 
                      `<div class="head">${metaValue}</div>`;

          productMetafields.forEach((product, i) => {
            if ( product === null ){
              compareHtml += `<div class="product product-${i} product-empty" data-metafield="${key}"></div>`;
              return;
            }

            let fieldValue = (product.metafields[metaKey] !== undefined ) ? product.metafields[metaKey] : '-';

            compareHtml += `<div class="product product-${i}" data-metafield="${key}">${fieldValue}</div>`;
          });
  
        compareHtml += '</div>';
      }
    }

    function buildMain(key, value){
      compareHtml += '<div class="row" data-main-row>' + 
                        `<div class="head"></div>`;

        productMetafields.forEach((product, i) => {
          if ( product === null ){
            compareHtml += `<div class="product product-${i} product-empty" data-main="${key}"></div>`;
            return;
          }

          //Image field
          if ( key === 'featured_image' ){
            compareHtml += `<div class="product product-${i}" data-main="${key}"><img src="${product[key]}" alt="${product}" /></div>`;
            return;
          }

          //Price
          if ( key === 'price' ){
            compareHtml += `<div class="product product-${i}" data-main="${key}"><span data-price="${product.type.toLowerCase()}">${product[key]}</span><a class="btn" href="${product.url}">View Product</a></div>`;
            return;
          }

          //Regular text field
          compareHtml += `<div class="product product-${i}" data-main="${key}">${product[key]}</div>`;

        });

      compareHtml += '</div>';
    }


  };

}

function setWithExpiry(key, value, ttl) {
	const now = new Date();

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	};
	localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key);
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null;
	}
	const item = JSON.parse(itemStr);
	const now = new Date();
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key);
		return null;
	}
	return item.value;
}

function addEvent(el, type, handler) {
  if (el.attachEvent) el.attachEvent('on'+type, handler); else el.addEventListener(type, handler);
}

function removeEvent(el, type, handler) {
  if (el.detachEvent) el.detachEvent('on'+type, handler); else el.removeEventListener(type, handler);
}

function get(url) {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();
    req.open('GET', url);
    req.onload = () => req.status === 200 ? resolve(req.response) : reject(Error(req.statusText));
    req.onerror = (e) => reject(Error(`Network Error: ${e}`));
    req.send();
  });
}


// ========================================================//
// Product Page Accordion Javascript
// ========================================================//

//Add Inactive Class To All Accordion Headers
$('.accordion-header').toggleClass('inactive-header');
//Set The Accordion Content Width
var contentwidth = $('.accordion-header').width();
$('.accordion-content').css({'width' : contentwidth });
//Open The First Accordion Section When Page Loads
// $('.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
// $('.accordion-content').first().slideDown(250).toggleClass('open-content');
// The Accordion Effect
$('.accordion-header').click(function () {
  if($(this).is('.inactive-header')) {
    $('.active-header').toggleClass('active-header').toggleClass('inactive-header').next().slideToggle(250).toggleClass('open-content');
    $(this).toggleClass('active-header').toggleClass('inactive-header');
    $(this).next().slideToggle(250).toggleClass('open-content');
  }
  else {
    $(this).toggleClass('active-header').toggleClass('inactive-header');
    $(this).next().slideToggle(250).toggleClass('open-content');
  }
});


// // ========================================================//
// // Product Info Page Tab Content Javascript
// // ========================================================//

// function openPage(pageName, elmnt) {
//   // Hide all elements with class="tabcontent" by default */
//   var i, tabcontent, tablinks;
//   tabcontent = document.getElementsByClassName("tabcontent");
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//   }

//   // Remove the background color of all tablinks/buttons
//   tablinks = document.getElementsByClassName("tablink");
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].style.backgroundColor = "";
//   }

//   // Show the specific tab content
//   document.getElementById(pageName).style.display = "block";

//   // Add the specific color to the button used to open the tab content
//   elmnt.style.backgroundColor = "#80c342";
// }

// // Get the element with id="defaultOpen" and click on it
// document.getElementById("defaultOpen").click();


/*============ Product page tabs - details  ==========*/

jQuery(document).ready(function ($) {

  // hide all additional tab content except #1
  $('.overflow-div').hide();
  $('.overflow-div[data-id="1"]').show();

  
  if ($('ul.tabs').length > 0) {
    $('ul.tabs').each(function (e) {
      var active, content, links  = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
     
      
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });

      $(this).find('a').click(function (e) {
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();

        // show 
        $('.overflow-div').hide();
        $('.overflow-div[data-id="'+ $(this).attr('data-id') +'"]').show();
        return false;
      });

    });
  }
});


$('.pagination').on("click",function(){
  $('html, body').animate({scrollTop:-40}, 'slow');
  return true;
});

// $(document).ready(function(){
//  $('.collection-sidebar__heading').addClass('closed');
//   $('.collection-sidebar__group ul').addClass('hide');
  
//     $(".collection-sidebar__heading").click(function(){
//     $(".collection-sidebar__heading").removeClass("closed");
//       $('.collection-sidebar__group ul').removeClass('hide');
//   });

// });

/*============ Add copyright icon  ==========*/
copyrightIcon();

function copyrightIcon(){
  const $sidebar = $('.collection__sidebar .fs-body-base');

  $sidebar.each(function(){
    let html = $(this).html();
    // console.log('test');  
    html = html.replace('Scrapeater', 'Scrapeater®');
    html = html.replace('Supertub', 'Supertub®');
    html = html.replace('Uniduct', 'Uniduct®');
    html = html.replace('Ironing Centre', 'Ironing Centre®');

    $(this).html(html);
  });
  
}
